const USER_STORAGE_KEY = 'user';

type StorageChange = Pick<StorageEvent, 'key' | 'newValue'>;

const storedClientId = (storedUser: string | null): string | null => {
  try {
    return JSON.parse(storedUser ?? 'null')?.clientId ?? null;
  } catch {
    return null;
  }
};

/**
 * Tells whether another tab replaced the session client: a client switch, a new login or a logout. The session
 * cookie is shared across tabs, so this tab would keep sending a workspace of a client the session no longer has.
 */
export const isSessionClientChange = (change: StorageChange, currentClientId?: string | null) => (
  (change.key === USER_STORAGE_KEY || change.key === null)
  && storedClientId(change.newValue) !== (currentClientId ?? null)
);

export const onSessionClientChangeInOtherTab = (currentClientId: string | null | undefined, listener: () => void) => {
  const handleStorage = (event: StorageEvent) => {
    if (isSessionClientChange(event, currentClientId)) listener();
  };
  window.addEventListener('storage', handleStorage);
  return () => window.removeEventListener('storage', handleStorage);
};
